import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { confirmSignup, login as loginAction, SignupOutcome, UserConstants } from '../actions/user';
import LoginPage from '../components/Login';

type AppDispatch = ThunkDispatch<RootReducerState, unknown, AuthenticationAction>;

interface MapStateToProps {
  auth: AuthenticationState
}

const mapStateToProps = (state: RootReducerState): MapStateToProps => {
  return {
    auth: state.authentication
  }
}

interface MapDispatchToProps {
  loginAction: (username: string, password: string) => (dispatch: Dispatch<AuthenticationAction>) => Promise<string>
  confirmSignupAction: (email: string, code: string, password: string) => Promise<SignupOutcome>
  clearError: () => void
}

const mapDispatchToProps = (dispatch: AppDispatch): MapDispatchToProps => ({
  ...bindActionCreators({ loginAction }, dispatch),
  confirmSignupAction: (email, code, password) => dispatch(confirmSignup(email, code, password)),
  clearError: () => dispatch({ type: UserConstants.CLEAR_AUTH_ERROR }),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
